//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getHostProducts } from "@api/store";
import Loading from "@components/Loading";
import { goShopDetail } from "@libs/order";
export default {
  name: "Recommend",
  props: {},
  components: {
    Loading: Loading
  },
  data: function data() {
    return {
      hostProduct: [],
      page: 1,
      limit: 20,
      loadTitle: "",
      loading: false,
      loadend: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.hostProducts();
    this.$scroll(this.$refs.container.parentElement, function () {
      !_this.loading && _this.hostProducts();
    });
  },
  methods: {
    // 商品详情跳转
    goDetail: function goDetail(item) {
      var _this2 = this;

      goShopDetail(item).then(function () {
        _this2.$router.push({
          path: "/detail/" + item.id
        });
      });
    },
    hostProducts: function hostProducts() {
      var that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；

      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；

      that.loading = true;
      getHostProducts(that.page, that.limit).then(function (res) {
        that.loading = false; //apply();js将一个数组插入另一个数组;

        that.hostProduct.push.apply(that.hostProduct, res.data);
        that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；

        that.page = that.page + 1;
      });
    }
  }
};